module.exports = __webpack_public_path__ + "static/media/RecomendaIndependenciaBrasil.742f84c7.jpg";